module.exports = __webpack_public_path__ + "img/login_padlock.577da161.png";